import req from './http.js'

// 取得所有倒數計時器設定檔
export const apiGetSettings = (page_idx, limit, container_id, org_id) => req('get', '/iframe/timer?container_id=' + container_id + '&page=' + page_idx + '&limit=' + limit + '&org=' + org_id)

// 更新設定檔
export const apiUpdateSetting = (params, id, org_id) => req('put', '/iframe/timer?id=' + id + '&org=' + org_id, params)

// 新增設定檔
export const apiCreateSetting = (params, org_id) => req('post', '/iframe/timer?org=' + org_id, params)

// 刪除設定檔
export const apiDeleteSetting = (id, org_id) => req('delete', '/iframe/timer?id=' + id + '&org=' + org_id)

// 取得單隻設定檔
export const apiGetSettingById = (id, org_id) => req('get', '/iframe/timer/by?id=' + id + '&org='+ org_id)

// 公開的API取得單個設定檔
export const apiGetSettingByIdPulic = id => req('get', '/view/timer?id=' + id)
